import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';
import Styled from 'styled-components';
import axios from 'axios';
import { incorrectToken } from '../../../lib/utils/incorrectToken';
import * as Sentry from "@sentry/react";

interface ApprovalListProps {
  setIsListData: Dispatch<SetStateAction<boolean>>;
}

export const ApprovalList = ({ setIsListData }: ApprovalListProps) => {
  const [listData, setListData] = useState<any[]>([]);

  useEffect(() => {
    fetchLoadList();
  }, []);

  const fetchLoadList = async () => {
    const token = sessionStorage.getItem('token');
    const approvalIdx = sessionStorage.getItem('apartmentRefIdx');

    try {
      const res = await axios.get(
        `${process.env.COMMON_URL}/common/approval/approvalwebadmin/${approvalIdx}`,
        { headers: { tokenID: token } }
      );

      if (res.data.ErrorCode === 0) {
        const data = res.data.Data;
        setListData(data);

        // ✅ 부모 컴포넌트(MonthlyPrinting)의 레이아웃을 결정하는 로직
        // 데이터가 아예 없거나, 모든 결재자 이름이 빈값('')인 경우 true (결재박스 숨김 처리용)
        if (data[0] && data[0].ApprovalWebData.every((item: any) => item.ApprovalName === '')) {
          setIsListData(true);
        } else if (!data[0]) {
          setIsListData(true);
        } else {
          setIsListData(false);
        }
      } else {
        Sentry.captureMessage(`Server Error : ErrorCode: ${res.data.ErrorCode}`);
        alert(`오류가 발생했습니다: ${res.data.ErrorMsg}`);
      }
      incorrectToken(res);
    } catch (e) {
      Sentry.captureException(e);
      console.error(e);
    }
  };

  // 렌더링할 결재 데이터 추출
  const approvalData = listData[0]?.ApprovalWebData || [];
  const hasVisibleData = !approvalData.every((d: any) => d.ApprovalName === '');

  // 만약 결재 데이터가 모두 비어있다면 아무것도 렌더링하지 않음
  if (!hasVisibleData) return null;

  return (
    <BoxContainer className="box-container">
      {listData[0] &&
        listData[0].ApprovalWebData.map((user, index) => {
          // 이름이 없거나 사용하지 않는 박스는 렌더링하지 않음
          if (!user.ApprovalName) return null;

          return (
            <ApprovalBox key={index}>
              <ApprovalNameBox>
                {user.ApprovalName}
              </ApprovalNameBox>
              {/* 하단 서명란(빈 공간) */}
              <div style={{ flex: 1 }}></div>
            </ApprovalBox>
          );
        })}
    </BoxContainer>
  );
};

const ApprovalBox = Styled.div`
  display: flex;
  flex-direction: column;
  width: 68px;
  height: 90px;
  /* 모든 박스는 왼쪽 선만 가집니다 */
  border-left: 1px solid black;
  background-color: white;

  // 인덱스 기반으로 마지막 선을 그리던 기존 'box-4'나 'off' 관련 복잡한 로직은 제거하세요.

  &.off {
    display: none; /* 미사용 항목은 아예 공간을 차지하지 않게 하거나 */
    /* 또는 숨기고 싶지 않다면 border를 투명하게 처리 */
  }
`;

const ApprovalNameBox = Styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 30px;
  padding: 5px;
  border-bottom: 1px solid black;
  font-size: 11px; /* 글자 크기가 크면 틀이 깨질 수 있으니 확인 */
  font-weight: 600;
`;

// 결재 박스들을 감싸는 부모 컨테이너에 위/오른쪽/아래 벽을 세워줍니다.
const BoxContainer = Styled.div`
  display: flex;
  border-top: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  /* 이렇게 하면 내부 박스들의 border-left와 합쳐져 완벽한 격자가 됩니다. */
`;